export default "__VITE_ASSET__DF2VBNZQ__"